var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3505 2.55149L10.8989 1.03555C10.7318 0.47868 10.212 0.0888672 9.63042 0.0888672H6.45005C5.86223 0.0888672 5.34867 0.472492 5.18161 1.03555L4.72992 2.55149H0.615234V3.78899H1.79705L2.50861 17.4201H13.5657L14.2772 3.78899H15.4652V2.55149H11.3505ZM6.36342 1.39443C6.3758 1.3573 6.40673 1.33255 6.45005 1.33255H9.63042C9.66755 1.33255 9.70467 1.3573 9.71086 1.39443L10.0326 2.47105H6.04167L6.36342 1.39443ZM12.3653 13.7014C12.2415 15.4772 10.2863 15.57 9.89648 15.57H6.15923C5.46623 15.57 3.83892 15.3906 3.71517 13.7014L3.05311 3.93749H13.0274L12.3653 13.7014ZM6.18398 5.66999H4.94648V13.7137H6.18398V5.66999ZM8.65898 5.66999H7.42148V13.7137H8.65898V5.66999ZM11.134 5.66999H9.89648V13.7137H11.134V5.66999Z",
    fill: "#EB1700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconRed);
export default __webpack_public_path__ + "static/media/TrashIconRed.70568c5fae57cadb3923b01a49983e84.svg";
export { ForwardRef as ReactComponent };